import { useEffect, useState } from 'react';
export const CONSENT_KEY = 'bigcircle:cookie-consent:v1';
const CHANGE = 'bigcircle:cookie-consent-change';
const MAX_AGE = 180 * 86400000;
export const getCookieConsent = () => {
  try {
    const saved = JSON.parse(localStorage.getItem(CONSENT_KEY));
    if (saved?.version === 1 && typeof saved.analytics === 'boolean' && Number.isFinite(saved.savedAt) && Date.now() - saved.savedAt < MAX_AGE && saved.savedAt <= Date.now()) return { analytics: saved.analytics, savedAt: saved.savedAt };
  } catch { /* Optional storage remains disabled when preferences are unavailable. */ }
  return { analytics: false, savedAt: null };
};
export const saveCookieConsent = ({ analytics }) => {
  try {
    localStorage.setItem(CONSENT_KEY, JSON.stringify({ version: 1, analytics: analytics === true, savedAt: Date.now() }));
    if (!analytics) sessionStorage.removeItem('bc_visit_session');
    window.dispatchEvent(new Event(CHANGE));
    return true;
  } catch { return false; }
};
export const openCookieSettings = () => window.dispatchEvent(new Event('bigcircle:open-cookie-settings'));
export const useCookieConsent = () => {
  const [consent, setConsent] = useState(getCookieConsent);
  useEffect(() => {
    const refresh = () => setConsent(getCookieConsent());
    window.addEventListener(CHANGE, refresh); window.addEventListener('storage', refresh);
    return () => { window.removeEventListener(CHANGE, refresh); window.removeEventListener('storage', refresh); };
  }, []);
  return consent;
};
